import React, { useState } from 'react';
import classNames from 'classnames';
import { GameSpecificFields } from '../../LiveCasino/GameSpecificFields';
import { ThumbnailBadge } from '../../ThumbnailBadge';
import { EndsInBadge } from '../../EndsInBadge';
import { ThumbnailFavoriteBadge } from '../../ThumbnailFavoriteBadge';

export const CasinoThumbnailInit = ({
    gameId,
    jackpotExpires,
    badges = [],
    showFavorites,
    showStripsGridUI,
    extraClassName,
    gameSpecificFieldsInfo,
}) => {
    const [gameFieldsGradientVisible, setGameFieldsGradientVisible] = useState(true);

    const className = classNames(
        'casino-thumbnail__init',
        extraClassName,
        {
            'casino-thumbnail__init--strips-grid-ui': showStripsGridUI,
        }
    );

    const specificFieldsClassName = gameSpecificFieldsInfo
        ? classNames(
            'live-casino-thumbnail__fields',
            {
                'live-casino-thumbnail__game-fields-gradient': gameFieldsGradientVisible,
            },
        )
        : '';

    return (
        <div className={className}>
            <div className="casino-thumbnail__init-wrap">
                <div className="casino-thumbnail__badges">
                    {jackpotExpires && <EndsInBadge jackpotExpires={jackpotExpires} />}
                    {badges.map((badge) => (<ThumbnailBadge
                        key={badge.badgeName}
                        badgeName={badge.badgeName}
                        badgeText={badge.badgeText}
                    />))}
                </div>
                {showFavorites && <ThumbnailFavoriteBadge gameId={gameId} />}
            </div>

            {gameSpecificFieldsInfo && <div className={specificFieldsClassName}>
                <GameSpecificFields
                    gameInfo={gameSpecificFieldsInfo}
                    showGradient={setGameFieldsGradientVisible}
                />
            </div>}
        </div>
    );
};
